import { z } from 'zod'
import { TwoFactorChallengeRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// A key absent from the raw input stays absent -- introducing it (even as null/undefined)
// would add a wire key callers never sent, breaking exact-body assertions downstream.
const normalize = fieldNormalizer({ blankToNull: ['code', 'recovery_code'] })

export const TwoFactorChallenge = (_context: NoContext) =>
  z.preprocess(normalize, TwoFactorChallengeRequestSchema)
